<template>
  <div style="padding-top: 16px" id="page-container">
    <div class="page-section jobs_container">
      <div :class="containerClass">
        <div class="d-flex flex-column flex-sm-row align-items-sm-center mb-24pt" style="white-space: nowrap">
          <h2 class="mb-0">
            Courses
          </h2>

          <div class="w-auto ml-sm-auto mb-sm-0" :class="{ 'd-flex': !isMobileScreen }">
            <div :class="isMobileScreen ? 'mt-2 ml-auto' : 'ml-3'">
              <b-btn :to="{ name: 'add-course' }" variant="primary" :class="{ 'w-100': isMobileScreen }"
                >Add Course</b-btn
              >
            </div>
          </div>
        </div>

        <div class="d-flex justify-content-center" v-if="!totalCourses && !isLoading">
          <div class="card card-block card-stretch card-height col-md-12">
            <div class="card-body text-center">
              <i class="fas fa-exclamation-circle fa-lg text-muted mt-4 mb-4" style="font-size: 3rem" />
              <h4>No Courses</h4>

              <p class="text-muted">
                Couldn't find any courses right now.
              </p>
            </div>
          </div>
        </div>

        <div class="card mb-0" v-if="totalCourses">
          <b-table
            :fields="tableColumns"
            :items="courses"
            :busy="isLoading"
            head-variant="light"
            class="table-nowrap"
            hover
            responsive
            no-local-sorting
            @sort-changed="onSortChange"
          >
            <template #head(actions)="">
              <span></span>
            </template>
            <template #cell(actions)="data">
              <router-link
                :to="{
                  name: 'edit-course',
                  params: { id: data.item.id },
                }"
                class="svg-icon mr-2"
                v-b-popover.hover.right
                :title="'Edit'"
              >
                <i class="material-icons">edit</i>
              </router-link>
            </template>
          </b-table>

          <!-- Footer Pagination -->
          <div class="card-footer">
            <pagination
              v-model="currentPage"
              :total-rows="totalCourses"
              :per-page="perPage"
              @change="onPageChange"
              aria-controls="schools-table"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { debounce, get } from 'lodash';
import Page from '@/components/Page.vue';
import Pagination from '../../../components/Ui/Pagination.vue';
import { mapActions, mapGetters } from 'vuex';
import DefaultAvatar from '@/assets/images/logos/logo_icon.png';
import { formatDateTime } from '../../../common/utils';

export default {
  components: { Pagination },
  extends: Page,

  data() {
    return {
      DefaultAvatar,
      title: 'Courses',
      isLoading: true,
      perPage: 14,
      currentPage: 1,
      totalCourses: 0,
      courses: [],
      windowWidth: window.innerWidth,
    };
  },

  computed: {
    ...mapGetters('auth', ['getLoggedInUser']),

    breadcrumb() {
      return [
        { text: this.$t('home'), to: this.routes.home },
        { text: 'Courses', active: true },
      ];
    },

    tableColumns() {
      return [
        { key: 'course_name', label: 'Course Name' },
        { key: 'college', label: 'College' },
        { key: 'year_taken', label: 'Completion Date' },
        { key: 'course_code', label: 'Course Code' },
        { key: 'term', label: 'Term' },
        {
          key: 'actions',
          tdClass: 'text-right',
          thStyle: { minWidth: '100px' },
        },
      ];
    },

    isMobSmallScreen() {
      return this.windowWidth <= 420;
    },

    isMobileScreen() {
      return this.windowWidth <= 720;
    },
  },

  methods: {
    goBack() {
      this.$router.go(-1);
    },
    ...mapActions('student', ['getAllCourses']),
    get,
    formatDateTime,

    async fetchCourses(pageNum = 1, params = {}) {
      this.isLoading = true;
      const response = await this.getAllCourses({
        limit: this.perPage,
        offset: (pageNum - 1) * this.perPage,
        ...params,
      });

      this.courses = response.data.results;
      this.currentPage = pageNum;
      this.totalCourses = response.data.count;
      this.isLoading = false;
    },

    onPageChange(pageNum) {
      this.fetchCourses(pageNum);
    },

    onSortChange(context) {
      this.ordering = context.sortDesc ? '-' + context.sortBy : context.sortBy;
      this.fetchCourses();
    },

    onSearch() {
      this.debouncedSearchCourses(this);
    },

    debouncedSearchOffers: debounce(vm => {
      vm.fetchCourses();
    }, 500),

    handleResize() {
      this.windowWidth = window.innerWidth;
    },
  },

  async mounted() {
    window.addEventListener('resize', this.handleResize);
    this.fetchCourses();
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
};
</script>
